export const company = {
  name: 'LYKKEVÆRK',
  tagline: 'Multiservice • Montage • Vedligehold',
  cvr: '46716825',
  phone: '+45 22 45 18 90',
  phoneHref: 'tel:+4522451890',
  email: 'kontakt@lykkevaerk.dk',
  /** Stående logo — bruges stort på hvide flader. */
  logo: 'https://cdn.magicpatterns.com/uploads/nHxi4VXqzJoxJUMisTPGYE/image.png',
  /** Liggende logo med gennemsigtig baggrund — bruges i topbjælker. */
  logoWide: 'https://cdn.magicpatterns.com/uploads/eUzyTHyvYNvXG7KJGUf9oy/FIRMAgennemsigtig.png',
  /** Adgangskode til admin-området. */
  adminPassword: 'VAERKLYKKE2026!!',
}

export interface Service {
  title: string
  description: string
  icon: 'wrench' | 'drill' | 'refresh'
}

export const services: Service[] = [
  {
    title: 'Multiservice',
    description: 'Praktiske opgaver, små reparationer og forskellige serviceopgaver.',
    icon: 'wrench',
  },
  {
    title: 'Montage',
    description: 'Montering og opsætning af inventar, udstyr og andre praktiske løsninger.',
    icon: 'drill',
  },
  {
    title: 'Vedligehold',
    description: 'Vedligeholdelse, reparation og løbende service.',
    icon: 'refresh',
  },
]

export const values = [
  {
    title: 'Ordentligt arbejde',
    description: 'Opgaven bliver lavet færdig, og der bliver ryddet op efter arbejdet.',
  },
  {
    title: 'Personlig kontakt',
    description: 'Du taler med den person, der udfører arbejdet — hele vejen.',
  },
  {
    title: 'Klare aftaler',
    description: 'Pris, omfang og tidspunkt er aftalt, inden vi går i gang.',
  },
]
